import { InjectionToken } from '@angular/core';

export interface TrialBannerConfig {
  showTrialBanner: boolean;
}

export const TRIAL_BANNER_CONFIG = new InjectionToken<TrialBannerConfig>(
  'tvd.trial-banner.config',
  {
    factory: () => ({ showTrialBanner: true }),
  },
);
